import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/pro-light-svg-icons'

import { Flex, TextField, Button, ButtonGroup } from '@dooer/react-ui-kit'

import { AcademyCustomerCategory } from '../../../../__generated__/globalTypes'
import AcademyCategoryIcon from '../../academy-category-icon'

import styles from './hero.module.scss'

interface IHeroProps {
  onSearchChange: (value: string) => void
  search: string | null
  onCustomerCategoryChange: (value: AcademyCustomerCategory) => void
  customerCategory: AcademyCustomerCategory
  onSubmit: () => void
}

const Hero: React.FC<IHeroProps> = (props) => {
  const intl = useIntl()

  return (
    <div className={styles.root}>
      <div className={styles.outer}>
        <div className={styles.inner}>
          <div className={styles.heading}>
            <h1>
              <Flex justifyContent="center" row>
                <FormattedMessage defaultMessage="Dooer Akademi" id="academy.hero.heading" />
                <AcademyCategoryIcon category={{ icon: 'academy' }} iconStyle="header" />
              </Flex>
            </h1>
            <h4>
              <FormattedMessage
                defaultMessage="Här hittar du svar på de vanligaste frågorna kring bokföring och hur du använder Dooer för att förenkla din vardag."
                id="academy.hero.description"
              />
            </h4>
            <Flex justifyContent="center" marginBottom="large">
              <ButtonGroup>
                <Button
                  onClick={() => props.onCustomerCategoryChange(AcademyCustomerCategory.free)}
                  outline={props.customerCategory !== AcademyCustomerCategory.free}
                  variant="cta"
                >
                  <FormattedMessage defaultMessage="Gratis produkter" id="academy.hero.customer-category-free" />
                </Button>
                <Button
                  onClick={() => props.onCustomerCategoryChange(AcademyCustomerCategory.paid)}
                  outline={props.customerCategory !== AcademyCustomerCategory.paid}
                  variant="cta"
                >
                  <FormattedMessage defaultMessage="Byråkund" id="academy.hero.customer-category-paid" />
                </Button>
              </ButtonGroup>
            </Flex>
            <Flex justifyContent="center" marginBottom="small" marginLeft="large" marginRight="large" row>
              <form
                onSubmit={(e) => {
                  e.preventDefault()
                  props.onSubmit()
                }}
              >
                <TextField
                  icon={<FontAwesomeIcon icon={faSearch} />}
                  onChange={(e) => props.onSearchChange(e.target.value)}
                  placeholder={intl.formatMessage({
                    defaultMessage: 'Sök i akademin...',
                    id: 'academy.hero.text-field.placeholder',
                  })}
                  style={{ borderRadius: 34 }}
                  value={props.search || ''}
                />
              </form>
            </Flex>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Hero
